<template>
    <v-col
        class="d-flex align-center justify-center mx-n1"
        lg="9"
        md="8"
        cols="12"
    >
        <v-row class="align-center justify-center flex-row no-wrap pa-8">
            <v-col>
                <v-row class="amounts-wrapper align-center">
                    <v-col
                        class="amount-wrapper flex-shrink-1 d-flex flex-column align-center justify-left"
                        :class="{ 'pt-0': order.is_partial_match_allowed }"
                    >
                        <div v-if="order.type === '3po'">
                            <p class="transfer-overline overline blue-grey--text lighten-4 mb-0">
                                You send
                            </p>
                            <p class="headline font-weight-medium mb-0">
                                <span class="pl-1 subtitle-2 font-weight-regular teal--text lighten-1">
                                    Any Amount {{ order.matcher_currency }}
                                </span>
                            </p>
                        </div>
                        <div v-else>
                            <p
                                class="transfer-overline overline blue-grey--text lighten-4 mb-0"
                                :class="{ 'mt-6': order.is_partial_match_allowed }"
                            >
                                {{
                                    order.is_partial_match_allowed ?
                                        `Can ${ isPoster ? 'Request' : 'Send' } Up To` :
                                        'You send'
                                }}
                            </p>
                            <p class="headline font-weight-medium mb-0">
                                {{ formatAmount(order.matcher_amount) }}
                                <span
                                    class="pl-1 subtitle-2 font-weight-regular teal--text lighten-1"
                                >{{ order.matcher_currency }}</span>
                            </p>
                            <p
                                v-if="order.pb_amount && order.pb_currency"
                                class="caption font-weight-medium mb-0"
                            >
                                ({{ formatAmount(order.pb_amount) }}
                                <span
                                    class="pl-1 caption font-weight-regular teal--text lighten-1"
                                >{{ order.pb_currency }}</span>)
                            </p>
                        </div>
                    </v-col>
                    <v-col
                        class="methods-wrapper align-center justify-center flex-grow-1"
                        :class="{ 'pt-0': order.is_partial_match_allowed }"
                    >
                        <v-row class="d-flex flex-row flex-nowrap">
                            <v-col
                                class="flex-grow-0 flex-shrink-1 pa-0"
                            >
                                <div class="d-flex align-center justify-center">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-avatar
                                                class="primary--outline"
                                                size="38"
                                                v-on="on"
                                            >
                                                <v-icon
                                                    color="primary"
                                                    size="18"
                                                >
                                                    {{ getPaymentMethod(order.poster_payment_method_type).icon || 'mdi-bank-outline' }}
                                                </v-icon>
                                            </v-avatar>
                                        </template>
                                        <span>{{ order.poster_payment_method_type | removeUnderscore }}</span>
                                    </v-tooltip>
                                </div>
                            </v-col>

                            <v-col class="d-none d-sm-flex flex-grow-1 align-center justify-center pa-0">
                                <v-icon
                                    color="blue-grey lighten-4"
                                    size="10"
                                >
                                    mdi-chevron-double-right
                                </v-icon>
                                <v-sheet
                                    color="blue-grey lighten-4"
                                    width="100%"
                                    height="2px"
                                />
                            </v-col>

                            <v-col
                                class="d-none d-sm-flex flex-grow-0 flex-shrink-1 align-center justify-center pa-0"
                            >
                                <!-- DURATION NEEDS FUNCTIONALITY -->
                                <v-chip
                                    disabled
                                    outlined
                                >
                                    {{ orderDuration }}
                                </v-chip>
                            </v-col>

                            <v-col class="d-none d-sm-flex flex-grow-1 align-center justify-center pa-0">
                                <v-sheet
                                    color="blue-grey lighten-4"
                                    width="100%"
                                    height="2px"
                                />
                                <v-icon
                                    color="blue-grey lighten-4"
                                    size="10"
                                >
                                    mdi-chevron-double-right
                                </v-icon>
                            </v-col>

                            <v-col class="d-sm-none hidden-sm-and-up">
                                <div class="d-flex align-center justify-center">
                                    <v-icon>
                                        mdi-arrow-down
                                    </v-icon>
                                </div>
                            </v-col>

                            <v-col
                                class="flex-grow-0 flex-shrink-1 pa-0"
                            >
                                <div class="d-flex align-center justify-center">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-avatar
                                                v-if="order.type === 'p2p'"
                                                class="primary--outline"
                                                size="38"
                                                v-on="on"
                                            >
                                                <v-icon
                                                    color="primary"
                                                    size="16"
                                                >
                                                    mdi-bank-outline
                                                </v-icon>
                                                <v-icon
                                                    color="primary"
                                                    size="16"
                                                >
                                                    mdi-cellphone-iphone
                                                </v-icon>
                                            </v-avatar>
                                            <v-avatar
                                                v-else
                                                class="primary--outline"
                                                size="38"
                                                v-on="on"
                                            >
                                                <v-icon
                                                    color="primary"
                                                    size="18"
                                                >
                                                    {{ getDeliveryMethod(order.matcher_payment_method_type).icon || 'mdi-bank-outline' }}
                                                </v-icon>
                                            </v-avatar>
                                        </template>
                                        <span>{{ order.matcher_payment_method_type | removeUnderscore }}</span>
                                    </v-tooltip>
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col
                        class="amount-wrapper flex-shrink-1 d-flex flex-column align-center justify-right"
                    >
                        <div v-if="order.type === '3po'">
                            <p class="transfer-overline overline blue-grey--text lighten-4 mb-0">
                                Recipient gets
                            </p>
                            <p class="headline font-weight-medium mb-0">
                                <span class="pl-1 subtitle-2 font-weight-regular teal--text lighten-1">
                                    Any Amount {{ order.poster_currency }}
                                </span>
                            </p>
                        </div>
                        <div v-else>
                            <p class="transfer-overline overline blue-grey--text lighten-4 mb-0">
                                {{ order.is_partial_match_allowed ? 'Can Receive Up To' : 'Recipient gets' }}
                            </p>
                            <p class="headline font-weight-medium mb-0 d-flex">
                                {{ formatAmount(order.poster_amount) }}
                                <span
                                    class="pl-1 subtitle-2 font-weight-regular teal--text lighten-1 mt-2"
                                >{{ order.poster_currency }}</span>
                            </p>
                        </div>
                    </v-col>
                </v-row>
                <v-row class="transfer-details-wrapper align-end">
                    <v-col class="flex-shrink-1">
                        <v-row class="text-center d-flex justify-space-between align-center">
                            <v-col
                                cols="auto"
                                sm="12"
                                class="pa-0"
                            >
                                <p
                                    class="transfer-overline overline blue-grey--text lighten-4 mb-0 text-left text-lg-center ml-lg-n4"
                                >
                                    Exchange rate
                                    <br v-if="$vuetify.breakpoint.smAndDown" />
                                    ({{ order.poster_currency }}/{{ order.matcher_currency }})
                                </p>
                            </v-col>

                            <v-sheet
                                tile
                                color="#f2f2f2"
                                class="py-3 px-5 grey--text text--darken-3 ml-lg-15 mb-3 mb-lg-0 rounded-lg"
                            >
                                <v-row class="text-left">
                                    <v-col
                                        cols="auto"
                                        sm="12"
                                        class="position-relative mr-3 mr-lg-8"
                                    >
                                        <p
                                            class="body-1 font-weight-medium mb-0"
                                        >
                                            <span class="mr-1">Before Fee:</span>
                                            {{ formatAmount(displayExchangeRate(order).toFixed(4)) }}
                                        </p>
                                        <p
                                            class="body-1 font-weight-medium mb-0"
                                        >
                                            <span class="mr-1">After Fee:</span>
                                            {{ formatAmount(order.eer && order.eer.toFixed(4)) }}
                                        </p>
                                        <div class="text-right mr-n6 mr-lg-0 mt-n5">
                                            <v-btn
                                                dark
                                                class="px-0"
                                                color="warning"
                                                icon
                                                @click="$emit('show-fees')"
                                            >
                                                <v-icon>mdi-help-circle</v-icon>
                                            </v-btn>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-sheet>
                        </v-row>
                    </v-col>

                    <!-- TRANSFER FEE NEEDS FUNCTIONALITY -->
                    <v-col class="flex-shrink-1 mb-lg-10">
                        <v-row class="text-center d-flex justify-space-between align-center">
                            <v-col
                                cols="auto"
                                sm="12"
                                class="pa-0"
                            >
                                <p class="transfer-overline overline blue-grey--text lighten-4 mb-0">
                                    Transfer fee
                                </p>
                            </v-col>

                            <v-col
                                cols="auto"
                                sm="12"
                                class="pa-0"
                            >
                                <!-- 3po -->
                                <p
                                    v-if="order.fakeFee >= 0"
                                    class="body-1 font-weight-medium mb-0"
                                >
                                    {{ formatAmount(order.fakeFee) }}
                                    <span
                                        class="pl-1 caption font-weight-regular teal--text lighten-1"
                                    >{{ order.matcher_currency }}</span>
                                </p>
                                <!-- p2p -->
                                <p
                                    v-if="order.type === 'p2p'"
                                    class="body-1 font-weight-medium mb-0"
                                >
                                    0.01 - 0.98
                                    <span
                                        class="pl-1 caption font-weight-regular teal--text lighten-1"
                                    >{{ order.matcher_currency }}</span>
                                </p>
                                <!-- hybrid -->
                                <template
                                    v-if="order.type === 'hybrid'"
                                >
                                    <p class="body-1 font-weight-medium mb-0">
                                        {{ order.company.name }} Fee - {{ (order.matcher_payment_method_fee).toFixed(2) }}
                                        <span
                                            class="pl-1 caption font-weight-regular teal--text lighten-1"
                                        >
                                            {{ order.matcher_currency }}
                                        </span>
                                    </p>
                                    <p class="body-1 font-weight-medium mb-0">
                                        Kaoshi Fee - 0.01 - 0.98
                                        <span
                                            class="pl-1 caption font-weight-regular teal--text lighten-1"
                                        >
                                            USD
                                        </span>
                                    </p>
                                </template>
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-col
                        class="flex-shrink-1 hidden-sm-and-up"
                    >
                        <v-row class="text-center d-flex justify-space-between align-center">
                            <v-col
                                cols="auto"
                                sm="12"
                                class="pa-0"
                            >
                                <p
                                    class="transfer-overline overline blue-grey--text lighten-4 mb-0"
                                >
                                    Duration
                                </p>
                            </v-col>

                            <v-col
                                cols="auto"
                                sm="12"
                                class="pa-0"
                            >
                                <p
                                    class="body-1 font-weight-medium mb-0"
                                >
                                    {{ orderDuration }}
                                </p>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row
                    v-if="isYourOfferTag"
                    class="justify-end hidden-sm-and-down"
                >
                    <v-col cols="auto">
                        <YourOfferTag :is-matcher="!isPoster" />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-col>
</template>
<script>
    import { mapGetters } from 'vuex';
    import YourOfferTag from './your-offer-tag.vue';

    export default {
        components: {
            YourOfferTag,
        },
        data() {
            return {};
        },
        props: getProps(),
        filters: getFilters(),
        computed: getComputed(),
        methods: getMethods(),
    };

    function getProps() {
        return {
            order: {
                type: Object,
                required: true,
            },
        };
    }

    function getFilters() {
        return {
            removeUnderscore(val) {
                return val && String(val).replace(/[_-]/g, ' ');
            },
        };
    }

    function getComputed() {
        return {
            ...mapGetters('paymentMethods', [
                'paymentMethods',
            ]),
            ...mapGetters('deliveryMethods', [
                'deliveryMethods',
            ]),
            orderDuration,
            p2pduration,
            isPoster() {
                return this.$store.state.user.can_post_offers;
            },
            isYourOfferTag() {
                if (!this.$store.state.user.id) {
                    return false;
                }
                if (this.order.type !== 'p2p') {
                    return false;
                }
                return this.$store.state.user.id === this.order.user_id
                    || this.$store.state.user.id === this.order.posters_beneficiary_user_id;
            },
        };

        function orderDuration() {
            if (this.order.time) {
                return this.order.time === 'NOT_DETERMINED_YET'
                    ? 'Not Available'
                    : this.order.time;
            }
            return this.p2pduration;
        }

        function p2pduration() {
            const currencies = [
                'KES',
                'ZAR',
            ];

            if (currencies.find((c) => c === this.order.poster_currency)) {
                return '2-3 days';
            }

            return '0-1 days';
        }
    }

    function getMethods() {
        return {
            displayExchangeRate,
            getPaymentMethod,
            getDeliveryMethod,
        };

        function displayExchangeRate(order) {
            if (order.type === '3po') {
                return order.exchange_rate;
            }
            return order.poster_amount / order.matcher_amount;
        }

        function getPaymentMethod(val) {
            const paymentMethod = this.paymentMethods.find(({ methods }) => methods.includes(val));
            return paymentMethod || {};
        }

        function getDeliveryMethod(val) {
            const deliveryMethod = this.deliveryMethods.find(({ methods }) => methods.includes(val));
            return deliveryMethod || {};
        }
    }
</script>

<style scoped>
.amount-wrapper:last-child {
    text-align: right;
}

.rate-button {
    top: 5px;
    right: 50px;
}

@media screen and (max-width: 600px) {
    .amounts-wrapper {
        display: grid;
        grid-template-columns: 5em 1fr;
        align-items: center !important;
    }

    .amount-wrapper {
        align-items: start !important;
    }

    .amount-wrapper:last-child {
        text-align: left;
    }

    .methods-wrapper {
        grid-column: 1 / 1;
        grid-row: 1 / 3;
    }

    .methods-wrapper > .row {
        flex-direction: column !important;
    }

    .transfer-details-wrapper {
        flex-direction: column;
        margin-top: 2em;
    }

    .transfer-overline {
        font-size: .75rem !important;
        font-weight: 500;
        letter-spacing: unset !important;
        line-height: initial;
        text-transform: unset !important;
    }
}

@media screen and (max-width: 767px) {
    .rate-button {
        top: -25px;
        right: -10px;
    }
}
</style>
